/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : documentLibraryAction.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author Abdul Rahim M-abdul@au79consulting.com
 * @date 03-12-2024
 * @description  Document Library API
 */
import actionType from "../actionTypes";
const documentLibraryAction = {
  //Document Library API
  get_df_reports: {
    api_name: "/ACM/intersections/user-dynamic-forms",
    https_method: "GET",
    action_type: actionType.GET_DF_REPORTS,
    description: "Get the Dynamic Forms In Reports",
  },
};

export default documentLibraryAction;
